<template>
    <v-tooltip v-if="showAnalyzeResults"
               top
               color="primary"
               max-width="500"
               open-delay="100">
        <template v-slot:activator="{ on }">

            <!--TOOLTIP CONTENTS -->
            <v-card
                class="d-flex align-self-center ml-1 pa-1 justify-center cursor-help"
                v-on="on"
                :color="feasibilityRunning ? 'grey' : calculateFeasibilityColor(item.availability, targetCompletes, item.estimated_response_rate)"
                style="margin-bottom: auto; margin-top: auto;"
                min-width="50"
                max-width="50"
                height="36">
                <div v-if="!feasibilityRunning"
                     class="body-1 align-self-center">

                    <div v-if="item.availability_multiplier !== null">

                        <div v-if="Math.round(item.availability_multiplier) < 1">
                            {{ Math.round(item.availability_multiplier * 100) / 100 }}
                        </div>

                        <div v-else-if="Math.round(item.availability_multiplier) < 10">
                            {{ Math.round(item.availability_multiplier * 10) / 10 }}
                        </div>

                        <div v-else-if="Math.round(item.availability_multiplier) < 100">
                            {{ Math.round(item.availability_multiplier) }}
                        </div>

                        <div v-else>
                            99+
                        </div>

                    </div>
                </div>

                <!-- LOADER -->
                <v-progress-circular v-if="feasibilityRunning"
                                     class="body-1 align-self-center"
                                     color="white"
                                     width="2"
                                     size="20"
                                     indeterminate
                ></v-progress-circular>

            </v-card>
        </template>

        <!-- TOOLTIP WARNINGS -->
        <v-alert icon="mdi-information"
                 type="error"
                 class="body-2 mt-2 mb-4"
                 max-width="300"
                 prominent
                 v-if="item.availability === 0 && item.estimated_response_rate > 0">
            It looks like no sample is available for this cell. Did you accidentally exclude this
            sell in the segment definition? If so you may disable this cell.
        </v-alert>

        <v-alert icon="mdi-information"
                 type="info"
                 class="body-2 mt-2 mb-4"
                 max-width="300"
                 prominent
                 v-else-if="item.availability_multiplier < 1 && item.estimated_response_rate === 0">
            It looks like the response rate for this cell is zero. If this is a brand
            new panel this is normal. Overtime when panelist matching this quota cell are invited
            the response rate will gradually increase.
        </v-alert>

        <v-alert icon="mdi-alert"
                 type="error"
                 class="body-2 mt-2 mb-4"
                 max-width="300"
                 prominent
                 v-else-if="item.availability_multiplier < 1 && item.estimated_response_rate > 0">
            It looks like we will not be able to complete this quota cell.
        </v-alert>

        <v-alert icon="mdi-alert"
                 type="warning"
                 class="body-2 mt-2 mb-4"
                 max-width="300"
                 prominent
                 v-else-if="item.availability_multiplier >= 1 && item.availability_multiplier <=2">
            It looks like it will be somewhat tight. While this cell contains up to two
            times the completes you need it is possible you might run out.
        </v-alert>

        <!-- TOOLTIP STATS -->
        <div class="pa-2">
            <div class="body-1 mb-1">
                <b>FEASIBILITY MULTIPLIER</b>
            </div>

            <div v-if="item.estimated_response_rate!==null">
                Estimated response rate:
                <b>{{ Math.round(item.estimated_response_rate).toLocaleString() }}%</b>
            </div>

            <div v-if="item.estimated_invites!==null && item.estimated_invites > 0">
                Invites needed: <b>{{ item.estimated_invites.toLocaleString() }}</b>
            </div>

            <div v-if="item.availability!==null">
                Availability: <b>{{ item.availability.toLocaleString() }}</b>
            </div>

        </div>

    </v-tooltip>
</template>

<script>

import Json from 'vue-json-pretty';
import {feasibilityColorMixin} from "../../../../components/mixins/feasilityColorMixin";

export default {

    mixins: [feasibilityColorMixin],

    components: {
        Json
    },
    
    props: {
        item: {
            type: Object,
            required: true,
        },

        mode: {
            type: String,
            required: true,
            validator: value => ['create','runtime'].includes(value)
        },

        targetCompletes: {
            type: Number | String,
            required: true,
        },

        feasibilityRunning: {
            type: Boolean,
            required: true,
            default: false,
        },

        showAnalyzeResults: {
            type: Boolean,
            required: true,
            default: false,
        }
    },

    data() {
        return {
        
        }
    },
    
    methods: {

    }
}
</script>
